module.exports = __webpack_public_path__ + "static/media/plant.dae92360.jpg";